import { render, staticRenderFns } from "./RedAlert.vue?vue&type=template&id=77b0adaa"
import script from "./RedAlert.vue?vue&type=script&lang=js"
export * from "./RedAlert.vue?vue&type=script&lang=js"
import style0 from "./RedAlert.vue?vue&type=style&index=0&id=77b0adaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports